import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ReceiptList = Loadable(
  lazy(() => import("features/receipt/components/List"))
);
const FineList = Loadable(
  lazy(() => import("features/fine/components/FineList"))
);
const routes = {
  path: "receipt",
  children: [
    { path: "", element: <ReceiptList /> },
    { path: "collectfine", element: <FineList /> },
  ],
};

export default routes;
